import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash handle=(component \"sortable-handle\"))}}\n\n", {
  moduleName: "ember-sortable/templates/components/sortable-item.hbs"
});